import React, { useState } from 'react'
import { useAppContext } from 'hooks/useAppContext';
import SkeletonGrid from 'components/Shared/SkeletonGrid'
import ChecklistGrid from './Checklist/GridChecklist';



const ChecklistSettings = ({callback}) => {
    const { selectedProject } = useAppContext() //Getting the App Context
    const title = "Checklist Settings"
    const [updateDate, setUpdateDate] = useState(new Date());

    return (
        <div key={updateDate}>
            {
                selectedProject ?
                    <ChecklistGrid callback={callback} />
                     :
                    <SkeletonGrid title={title} />
            }
        </div>
    )

}

export default ChecklistSettings
